(function () {
  if (window.PromoOffer) return;

  function formatMoney(cents) {
    if (window.theme?.Currency?.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  async function post(url, body) {
    const response = await (window.theme?.cartReads?.request || fetch)(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
      credentials: 'same-origin'
    });
    if (!response.ok) throw new Error(`${url} failed`);
    return response.json();
  }

  function addToCart(items) {
    return post('/cart/add.js', { items });
  }

  /* PDP */

  // Same metafield sale as the PDP price block: "amount:<cents>" or "pct:<n>"
  function salePrice(price, rule = '') {
    const [kind, value] = rule.split(':');
    if (kind === 'amount') return Math.max(0, price - Number(value));
    if (kind === 'pct') return price - Math.floor((price * Number(value)) / 100);
    return price;
  }

  function pdpBlock() {
    return document.querySelector('.product-single__meta [data-promo-offer]');
  }

  function checkedAddon(block) {
    return block?.querySelector('[data-promo-offer-addon]:checked') || null;
  }

  function updatePdp(block, variant) {
    if (!block) return;
    if (variant && block.dataset.pageRole === 'single') {
      const price = salePrice(variant.price, block.dataset.saleRule);
      block.dataset.selfPrice = price;
      const singlePrice = block.querySelector('[data-promo-offer-single-price]');
      if (singlePrice) singlePrice.textContent = formatMoney(price);
    }

    const selfPrice = Number(block.dataset.selfPrice) || 0;
    const addon = checkedAddon(block);
    // With an add-on the customer pays the add-on bundle's price
    const total = addon ? Number(addon.dataset.bundlePrice) || 0 : selfPrice;

    document.querySelectorAll('form.product-single__form').forEach(form => {
      const button = form.querySelector('[data-add-to-cart]');
      const text = form.querySelector('[data-add-to-cart-text]');
      if (!button || !text || button.disabled) return;
      text.textContent = `${block.dataset.atcLabel} — ${formatMoney(total)}`;
    });

    const note = document.querySelector('[data-promo-offer-note]');
    if (note && block.dataset.pageRole === 'single') {
      if (!note.dataset.defaultText) note.dataset.defaultText = note.textContent.trim();
      const addonPrice = addon ? Number(addon.dataset.price) || 0 : 0;
      note.textContent = addon
        ? `${block.dataset.selfName} ${formatMoney(total - addonPrice)} + ${addon.dataset.name} ${formatMoney(addonPrice)}`
        : note.dataset.defaultText;
    }
  }

  // With an add-on checked, the add-on bundle is added instead of the product; otherwise null.
  function bundleItems(form) {
    const addon = checkedAddon(pdpBlock());
    if (!addon) return null;
    const quantity = Number(new FormData(form).get('quantity')) || 1;
    return [{ id: Number(addon.dataset.bundleVariant), quantity }];
  }

  document.addEventListener('change', event => {
    const input = event.target.closest('[data-promo-offer-addon]');
    if (!input) return;
    const block = input.closest('[data-promo-offer]');
    // One add-on package at a time
    if (input.checked) {
      block.querySelectorAll('[data-promo-offer-addon]').forEach(other => {
        if (other !== input) other.checked = false;
      });
    }
    updatePdp(block);
  });

  document.addEventListener('variant:change', event => {
    const variant = event.detail?.variant;
    if (!variant?.available) return;
    // Let the theme update the button first
    setTimeout(() => updatePdp(pdpBlock(), variant), 0);
  });

  /* Cart drawer: swap lines (upgrade, add-on, remove add-on) */

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-promo-offer-swap]');
    if (!button || button.disabled) return;
    event.preventDefault();

    // Items are variant ids or { id, properties }
    const items = JSON.parse(button.dataset.items || '[]').map(item =>
      typeof item === 'object' ? { quantity: 1, ...item } : { id: Number(item), quantity: 1 }
    );
    const updates = JSON.parse(button.dataset.updates || '{}');

    button.disabled = true;
    button.classList.add('is-loading');
    try {
      // Add first so a failed add never removes what the customer had
      if (items.length) await addToCart(items);
      if (Object.keys(updates).length) await post('/cart/update.js', { updates });
    } catch (error) {
      console.error(error);
    }
    // The cart page has no drawer: rebuild it with the theme's cart form
    if (button.closest('.cart-page-content')) {
      const cartForm = document.querySelector('#CartPageForm')?._cartFormInstance;
      if (cartForm) cartForm.buildCart();
      else window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  });

  // Came from another "Build your kit" option (#kit): on mobile, bring the block back into view
  function scrollToKit() {
    const block = pdpBlock();
    if (!block || window.location.hash !== '#kit' || !window.matchMedia('(max-width: 989px)').matches) return;
    const scroll = () => block.scrollIntoView({ block: 'start' });
    scroll();
    // Gallery images above push the block down as they load
    window.addEventListener('load', scroll, { once: true });
  }

  function init() {
    updatePdp(pdpBlock());
    scrollToKit();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.PromoOffer = { bundleItems, addToCart };
})();
